<template>
    <div class="user-block">
        <span v-html="userInfo.username"></span>
        <a class="logout-btn" @click="e => this.G.logout(this)">退出登录</a>
    </div>
</template>

<script>
import { GLOBAL } from '../common/global.func.js';
export default {
    data() {
        return {
            userInfo:{
                username:'',
                urls:[]
            }
        };
    },
    mounted(){
        this.userInfo = GLOBAL.getCurrentUser(this)
    }
};
</script>

<style scoped>
.user-block{
    float: right;
    color: white;
    height: 42px;
    line-height: 42px;
    padding-right: 10px;
}

.logout-btn{
    margin-left: 15px;
}

</style>
